import ErrorTextMixin from './error-text-mixin.js';
import DisableableMixin from './disableable-mixin.js';
import FloatingLabelForFilledInputMixin from './labels/floating-label-for-filled-input-mixin.js';
import FocusableMixin from './focusable-mixin.js';
import HelperTextMixin from './helper-text-mixin.js';
import InputStateContainerMixin from './input-state-container-mixin.js';
import LabelMixin from './labels/label-mixin.js';
import PlaceholderMixin from './placeholder-mixin.js';
import ThemedInputMixin from './themed-input-mixin.js';

function FilledFloatingLabelInputBaseMixin(Base) {

  return class FilledFloatingLabelInput extends
    InputStateContainerMixin(
    ErrorTextMixin(
    HelperTextMixin(
    FloatingLabelForFilledInputMixin(
    LabelMixin(
    FocusableMixin(
    DisableableMixin(
    PlaceholderMixin(
    ThemedInputMixin(
      Base
  ))))))))) {}
}

export default FilledFloatingLabelInputBaseMixin;
